<template>
    <div id="cinlin" class="container">
        <h1>{{ this.$options.name }}</h1>
        <p>
            Search for backport commits in Linux kernel releases.
        </p>
        <search/>
    </div>
</template>

<script>
    import Search from '@/components/search'

    export default {
        name: 'CinLin',
        components: {
            Search
        }
    }
</script>

<style>
    #cinlin {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
